"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.name.placeholder': 'Ingresa tu nombre',
};
